import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { NAVIGATION_LABELS } from '../../../helpers/constants'
import NavigationLabel from '../../NavigationLabel/NavigationLabel'

const ResidentEventsLink = ({ withUpsellingRedirect }) => {
  const { t } = useTranslation(['navbar'])

  return (
    <div className="hover-menu-item">
      <NavLink
        className={({ isActive }) =>
          isActive ? 'navmgr-item__link--active' : 'hover-menu-item__link'
        }
        to={
          withUpsellingRedirect
            ? '/dashboard/upselling/residentEvents'
            : '/dashboard/resident-events'
        }
      >
        <span>
          {t('navbar:upsellingLinks.eventMarketplace')}
          <NavigationLabel type={NAVIGATION_LABELS.NEW} locked={withUpsellingRedirect} />
        </span>
      </NavLink>
    </div>
  )
}

ResidentEventsLink.propTypes = {
  withUpsellingRedirect: PropTypes.bool,
}

export default ResidentEventsLink
